import { render, staticRenderFns } from "./FileUploadQuestion.vue?vue&type=template&id=56034178&scoped=true"
import script from "./FileUploadQuestion.vue?vue&type=script&lang=js"
export * from "./FileUploadQuestion.vue?vue&type=script&lang=js"
import style0 from "./FileUploadQuestion.vue?vue&type=style&index=0&id=56034178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56034178",
  null
  
)

export default component.exports